'use strict';

module.exports = {
    defaultParkingLotState: 'isDefaultParkingLotState',
    defaultPlanningState: 'isDefaultPlanningState',
};
